import { Column } from "@/components/Column";

// Branches drawn as tapering strokes so they curl like a gnarled oak.
const BRANCHES = [
  { d: "M27 36 C20 31 14 31 9 25 C6 21 7 16 3 13", width: 2.4 },
  { d: "M9 25 C5 26 2 24 1 20", width: 1.2 },
  { d: "M26 26 C22 18 18 14 19 7 C20 3 17 1 14 2", width: 1.9 },
  { d: "M33 34 C40 30 45 31 51 25 C55 21 54 16 58 13", width: 2.4 },
  { d: "M51 25 C55 27 58 25 59 21", width: 1.2 },
  { d: "M30 26 C32 18 36 14 35 7 C34 3 37 1 40 2", width: 1.8 },
  { d: "M15 30 C13 34 10 34 7 37", width: 1 },
  { d: "M45 30 C47 34 50 34 53 37", width: 1 },
  { d: "M19 13 C15 11 13 8 13 4", width: 0.9 },
  { d: "M35 13 C39 11 41 8 41 4", width: 0.9 },
  { d: "M5 15 C3 13 3 10 5 8", width: 0.7 },
  { d: "M55 15 C57 13 57 10 55 8", width: 0.7 },
];
const BARK_COLOR = "#241a22";

// Bare, twisted stand-in for PlayyardTree: a flared trunk with a knot hole
// and curling limbs.
export const PlayyardSpookyTree = ({
  left,
  top,
  sizeCqw,
}: {
  left: number;
  top: number;
  sizeCqw: number;
}) => {
  return (
    <Column
      className="absolute -translate-x-1/2 -translate-y-full"
      style={{
        left: `${left.toString()}%`,
        top: `${top.toString()}%`,
        width: `${(sizeCqw * 1.5).toString()}cqw`,
        height: `${(sizeCqw * 1.75).toString()}cqw`,
      }}
    >
      <svg className="h-full w-full" viewBox="0 0 60 70">
        <path
          d="M22 70 Q26 66 26 60 C27 50 25 44 27 37 C28 31 26 27 24 22 L31 23 C32 29 34 33 33 40 C33 48 33 58 35 64 Q37 68 41 70Z"
          fill={BARK_COLOR}
        />
        {BRANCHES.map((branch) => (
          <path
            key={branch.d}
            d={branch.d}
            stroke={BARK_COLOR}
            strokeWidth={branch.width}
            strokeLinecap="round"
            fill="none"
          />
        ))}
        <ellipse cx="30" cy="50" rx="1.8" ry="2.8" fill="#0c080d" />
      </svg>
    </Column>
  );
};
